import { render, staticRenderFns } from "./BusinessVoucherHistory.vue?vue&type=template&id=30290f07&scoped=true"
import script from "./BusinessVoucherHistory.vue?vue&type=script&lang=js"
export * from "./BusinessVoucherHistory.vue?vue&type=script&lang=js"
import style0 from "./BusinessVoucherHistory.vue?vue&type=style&index=0&id=30290f07&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30290f07",
  null
  
)

export default component.exports